import React from 'react';
import { StyledGhostVipBadge } from 'templates/Balances/Ghost/GhostVipBadge/style';

type GhostVipBadgeProps = {
  playerLevelImg?: string;
};

export const GhostVipBadge: React.FC<GhostVipBadgeProps> = ({
  playerLevelImg,
}) => {
  return (
    <StyledGhostVipBadge>
      <img src={playerLevelImg} alt="vip" className="badge" />
    </StyledGhostVipBadge>
  );
};
